import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.lastScrollTop = 0
    this.isHeaderHidden = false

    // 初始定位
    this.element.style.paddingTop = '0'

    this.setupScrollListener()
  }

  setupScrollListener() {
    window.addEventListener('scroll', this.handleScroll.bind(this))
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const scrollingDown = scrollTop > this.lastScrollTop

    if (scrollingDown) {
      // 向下滚动
      if (scrollTop > 100 && !this.isHeaderHidden) {
        // 添加固定定位
        this.element.classList.add('fixed', 'top-0', 'w-full', 'z-30', 'shadow-md')
        document.body.style.paddingTop = this.element.offsetHeight + 'px'
        this.isHeaderHidden = true
      }
    } else {
      // 向上滚动 - 保持面包屑导航可见
      if (scrollTop > 50) {
        // 仍处于页面中滚动状态，保持面包屑导航固定
        this.element.classList.add('fixed', 'top-0', 'w-full', 'z-30', 'shadow-md')
        document.body.style.paddingTop = this.element.offsetHeight + 'px'
        this.isHeaderHidden = true
      } else {
        // 已滚动到顶部附近，恢复原始布局
        this.element.classList.remove('fixed', 'top-0', 'w-full', 'z-30', 'shadow-md')
        document.body.style.paddingTop = '0'
        this.isHeaderHidden = false
      }
    }

    this.lastScrollTop = scrollTop
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll.bind(this))
  }
}
